import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import SliderRow from './../../../reusable/Form/SliderRow';

export default class SliderExperianLevelsStability extends Component {

    constructor(props) {
        super(props);

        this.onSliderChange = this.onSliderChange.bind(this);
    }

    onSliderChange(value, riskAngleKey) {
        let changedRiskAngle = {};
        changedRiskAngle[riskAngleKey] = value;

        this.props.changeExperianSliders(changedRiskAngle);
    }

    render() {

        return (
            <div className="risk-sliders">

                <div className="risk-sliders__labels">
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.veryHigh'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.high'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.mediumHigh'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.medium'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.lowMedium'/>
                    </span>
                    <span className="risk-angle-label">
                        <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk.low'/>
                    </span>
                </div>

                <SliderRow key={'delinquency-risk-slider'}
                           ref={'delinquencyRisk'}
                           label={'Alerts_Create_UIText_name.step1.experianSection.delinquencyRisk'}
                           value={this.props.delinquencyRisk}
                           onChange={this.onSliderChange}
                           onChangeData={'delinquencyRisk'}
                           min={0}
                           max={5} />

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.SliderExperianLevelsDelinquency.jsx